import * as React from 'react'
import { Link } from 'react-router-dom'
import { Button } from "@mui/material"

import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

const styles = {
    div: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    loginBtn: (isMobile) => ({
        display: isMobile ? { xs: 'flex', md: 'none' } : { xs: 'none', md: 'flex' },
        fontFamily: 'inherit',
        textTransform: 'none',
        padding: '.4rem .9rem',
        borderRadius: '50px',
        background: '#fff',
        boxShadow: "0px 2px 4px #000",
        color: 'primary.black',
        fontSize: isMobile ? '.8rem' : '.9rem',
        fontWeight: 600,
        '&:hover': {
            background: "#000",
            color: "#fff"
        },
    }),
    signupBtn: (isMobile) => ({
        display: isMobile ? { xs: 'flex', md: 'none' } : { xs: 'none', md: 'flex' },
        fontFamily: 'inherit',
        textTransform: 'none',
        padding: '.5rem 1rem',
        ml: 1,
        borderRadius: '50px',
        backgroundColor: 'primary.black',
        boxShadow: "0px 3px 5px #000",
        color: 'text.regular',
        fontSize: '.9rem',
        fontWeight: 800,
        '&:hover': {
            background: "#fff",
            color: "#000"
        },
    })


}

export default function LoginSignUpButtons({ isMobile }) {

    return (
        <div style={styles.div}>
            <Button
                component={Link}
                to='/login'
                sx={styles.loginBtn(isMobile)}>
                {isMobile ? 'Login' : 'Log in'}
            </Button>
            <Button
                component={Link}
                to='/signup'
                endIcon={<ArrowForwardIcon />}
                sx={styles.signupBtn(isMobile)}>
                {isMobile ? 'Sign Up' : 'Get Started'}
            </Button>
        </div>
    )
}
